import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material";

export default makeStyles<Theme>(() => ({
  root: {
    display: "flex",
    alignItems: "center",
    width: 130,
    backgroundColor: "#FFFFFF",
  },
  button: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: 40,
    height: 40,
    flexShrink: 0,
    backgroundColor: "rgba(0, 0, 0, 0.04)",
    borderStyle: "solid",
    borderColor: "rgba(0, 0, 0, 0.12)",
    borderRadius: 0,
    "&.Mui-disabled": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  buttonLeft: {
    borderWidth: "1px 0px 1px 1px",
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
  },
  buttonRight: {
    borderWidth: "1px 1px 1px 0px",
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
  },
  value: {
    flex: 1,
    height: 40,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "0 14px",
    borderStyle: "solid",
    borderWidth: "1px",
    borderColor: "rgba(0, 0, 0, 0.23)",
    color: "rgba(0, 0, 0, 0.6)",
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 1.5,
  },
}));
